"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useManageNodeMenu = void 0;
const react_1 = require("react");
const feature_flags_1 = require("../../../../feature-flags");
const hooks_1 = require("../../../../hooks");
const store_1 = require("../../../../store");
const useManageNodeMenu = () => {
    const { featureFlagsService } = (0, hooks_1.useFeatureFlagsService)();
    const isProductTreeEditingAllowed = (0, store_1.useIsProductTreeEditingAllowed)();
    const isProductTreeGlobalTaxonomy = (0, store_1.useIsProductTreeGlobalTaxonomy)();
    const isProductTreeEditingEnabled = featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.TaxonomyEdits)
        && isProductTreeEditingAllowed
        && isProductTreeGlobalTaxonomy;
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const [productTreeNode, setProductTreeNode] = (0, react_1.useState)(null);
    const onOpenManageNodeMenu = (0, react_1.useCallback)((elem, node) => {
        setAnchorEl(elem);
        setProductTreeNode(node);
    }, []);
    const onCloseManageNodeMenu = (0, react_1.useCallback)(() => setAnchorEl(null), []);
    const onResetTreeNode = (0, react_1.useCallback)(() => setProductTreeNode(null), []);
    return {
        isProductTreeEditingEnabled,
        anchorEl,
        selectedProductTreeNode: productTreeNode,
        onOpenManageNodeMenu,
        onCloseManageNodeMenu,
        setProductTreeNode,
        onResetTreeNode,
    };
};
exports.useManageNodeMenu = useManageNodeMenu;
